import { SwapVert } from '@mui/icons-material';

export const UnsortedColumnIcon = ({ className }: { className?: string }) => (
  <SwapVert fontSize='small' className={className} />
);
